export default __webpack_public_path__ + "159cd82efad78479ffa1748a262d5f06.png";